export const getPreparationIngredientGroupKey = (
  kind: 'product' | 'semi',
  id: number | null | undefined,
  weightType: string,
  fallbackName: string
) => {
  const normalizedUnit = weightType.trim().toLocaleLowerCase('uk');
  if (id != null && id > 0) return `${kind}:${id}:${normalizedUnit}`;
  return `name:${kind}:${fallbackName.trim().toLocaleLowerCase('uk')}:${normalizedUnit}`;
};
